import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { blogs } from '../data/blogsData';
import { FAQitem } from '../utils/FAQitem';

const Blog4 = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const blogData = blogs.find(b => b.id === 4);

    return (
        <div className="bg-white">
            <div className="max-w-[1180px] mx-auto px-5 py-5  ">
                <button
                    onClick={() => navigate('/blogs')}
                    className="inline-flex fixed top-30 bg-black p-1 rounded-full hover:scale-110 items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors text-sm font-medium mb-5"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="19" y1="12" x2="5" y2="12"></line>
                        <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                </button>
            </div>

            <div className="max-w-[1180px] mx-auto px-5 pb-[70px] flex flex-col lg:flex-row items-start gap-10">
                <main className="flex-1 max-w-full lg:max-w-[760px] min-w-0">
                    {/* <div className="text-xs text-gray-400 mb-[18px]">
                        Car Care &nbsp;›&nbsp; Off-Road Preparation
                    </div> */}

                    <section className="pb-6 border-b border-gray-200 mb-7">
                        <h1 className="text-3xl md:text-4xl lg:text-[42px] leading-[1.15] mb-3.5 text-gray-900 font-bold tracking-tight">
                            
                        </h1>
                        <h1 className="text-3xl md:text-4xl lg:text-[42px] leading-[1.15] mb-3.5 text-gray-900 font-bold tracking-tight">
                            10 Things to Check Before Taking Your Vehicle Off-Road
                        </h1>

                        <p className="text-lg md:text-xl text-gray-600 mb-[18px]">
                            Heading off-road can be exciting, but rough terrain is much less forgiving than normal pavement. A little preparation before you leave can protect your vehicle, improve traction, and help you avoid getting stranded.
                        </p>

                        <div className="text-sm text-gray-500">
                            By <strong className="text-gray-900">CarFido Editorial Team</strong>
                            &nbsp;|&nbsp; Updated March 2026 &nbsp;|&nbsp; 11 min read
                        </div>
                    </section>

                    <figure className="mb-8">
                        <img
                            src="/blogs/4_1.jpeg"
                            alt="Vehicle being checked before an off-road drive"
                            title="10 Things to Check Before Taking Your Vehicle Off-Road"
                            className="w-full h-auto block border border-gray-300 rounded-xl"
                        />
                        <figcaption className="text-xs text-gray-400 mt-2">
                            Featured image: offroad_vehicle_checklist_featured.png
                        </figcaption>
                    </figure>

                    <nav className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-8">
                        <div className="text-base font-bold text-gray-900 mb-2.5">
                            In this article
                        </div>

                        <ul className="m-0 pl-[18px] text-gray-700 list-disc space-y-1">
                            <li><a href="#quick-answer" className="text-gray-900 no-underline hover:underline">Quick answer</a></li>
                            <li><a href="#checklist-table" className="text-gray-900 no-underline hover:underline">Off-road checklist summary</a></li>
                            <li><a href="#why-it-matters" className="text-gray-900 no-underline hover:underline">Why this matters</a></li>
                            <li><a href="#check-1" className="text-gray-900 no-underline hover:underline">1. Tires and tire pressure</a></li>
                            <li><a href="#check-2" className="text-gray-900 no-underline hover:underline">2. Spare tire and tools</a></li>
                            <li><a href="#check-3" className="text-gray-900 no-underline hover:underline">3. Suspension and steering</a></li>
                            <li><a href="#check-4" className="text-gray-900 no-underline hover:underline">4. Ground clearance and underbody</a></li>
                            <li><a href="#check-5" className="text-gray-900 no-underline hover:underline">5. Fluids</a></li>
                            <li><a href="#check-6" className="text-gray-900 no-underline hover:underline">6. Battery and charging</a></li>
                            <li><a href="#check-7" className="text-gray-900 no-underline hover:underline">7. Brakes</a></li>
                            <li><a href="#check-8" className="text-gray-900 no-underline hover:underline">8. Air filter and cooling</a></li>
                            <li><a href="#check-9" className="text-gray-900 no-underline hover:underline">9. Recovery gear</a></li>
                            <li><a href="#check-10" className="text-gray-900 no-underline hover:underline">10. Lights, communications, and supplies</a></li>
                            <li><a href="#dash-section" className="text-gray-900 no-underline hover:underline">Track off-road readiness with CarFido</a></li>
                            <li><a href="#extra-tips" className="text-gray-900 no-underline hover:underline">Extra off-road tips</a></li>
                            <li><a href="#faq" className="text-gray-900 no-underline hover:underline">FAQ</a></li>
                        </ul>
                    </nav>

                    <section className="mb-8 overflow-hidden">
                        <p className="mb-[18px]">
                            Taking your vehicle off-road is very different from driving on the street. Loose gravel, mud, sand, steep inclines, deep ruts, and rocky trails can quickly expose weak points in your tires, suspension, cooling system, and recovery setup.
                        </p>

                        <p className="mb-[18px]">
                            That is why it is smart to use a simple off-road vehicle checklist before every trip. Even if your car or SUV feels fine during daily driving, off-road conditions put much more strain on major components and make minor issues show up fast.
                        </p>

                        <p className="mb-0">
                            This guide covers 10 important things to check before taking your vehicle off-road, along with practical tips that can help you stay safer, avoid damage, and enjoy the trail with more confidence.
                        </p>
                    </section>

                    <section
                        id="quick-answer"
                        className="mb-9 bg-gray-50 border-l-4 border-gray-900 rounded-lg p-[18px]"
                    >
                        <div className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-2">
                            Quick Answer
                        </div>
                        <p className="m-0 text-gray-900 font-medium">
                            <strong>What should you check before taking your vehicle off-road?</strong><br />
                            Before going off-road, inspect tires, tire pressure, spare tire, suspension, underbody condition, fluids, battery, brakes, air filter, cooling system, recovery gear, and emergency supplies. Good preparation reduces the risk of getting stuck or damaging your vehicle.
                        </p>
                    </section>

                    <section id="checklist-table" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Off-Road Checklist Summary
                        </h2>

                        <div className="overflow-x-auto border border-gray-200 rounded-xl">
                            <table className="w-full border-collapse bg-white text-sm">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="text-left py-3.5 px-4 border-b border-gray-200 text-gray-900 font-bold">Item to Check</th>
                                        <th className="text-left py-3.5 px-4 border-b border-gray-200 text-gray-900 font-bold">Why It Matters</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 border-b border-gray-200 font-medium">Tires, pressure, spare tire</td>
                                        <td className="py-3.5 px-4 border-b border-gray-200 text-gray-600">Improves traction and helps prevent getting stranded</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 border-b border-gray-200 font-medium">Suspension, steering, brakes</td>
                                        <td className="py-3.5 px-4 border-b border-gray-200 text-gray-600">Maintains control on uneven ground</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 border-b border-gray-200 font-medium">Fluids, cooling, battery</td>
                                        <td className="py-3.5 px-4 border-b border-gray-200 text-gray-600">Protects the engine and keeps the vehicle reliable</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 font-medium">Recovery gear and emergency supplies</td>
                                        <td className="py-3.5 px-4 text-gray-600">Helps you handle stuck situations and remote-area problems</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section id="why-it-matters" className="mb-11">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Why Checking Your Vehicle Before Off-Road Driving Matters
                        </h2>

                        <p className="mb-4 text-gray-700">
                            Off-road driving is harder on your vehicle than normal commuting. Uneven surfaces can twist suspension components, loose surfaces can reduce traction, mud and sand can overload the cooling system, and sharp rocks can damage tires or underbody parts.
                        </p>

                        <p className="mb-5 text-gray-700">
                            A few minutes of preparation can make a huge difference. It helps you identify problems before they become expensive damage and gives you a better chance of getting through the trail safely and back home without trouble.
                        </p>

                        <ul className="pl-6 m-0 space-y-2 text-gray-700 list-disc">
                            <li>Reduces the chance of breakdowns in remote areas</li>
                            <li>Improves traction and vehicle control</li>
                            <li>Helps protect expensive components</li>
                            <li>Improves safety for you and your passengers</li>
                        </ul>
                    </section>

                    <figure className="mb-10">
                        <img
                            src="/blogs/4_2.jpeg"
                            alt="Checking off-road tires before entering rough terrain"
                            title="Tire inspection before off-road driving"
                            className="w-full h-auto block border border-gray-300 rounded-xl"
                        />
                        <figcaption className="text-xs text-gray-400 mt-2">
                            Inline image: offroad_tire_check.png
                        </figcaption>
                    </figure>

                    <section id="check-1" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            1. Check Tires and Tire Pressure
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Tires are one of the most important things to check before taking your vehicle off-road. On rough terrain, tires are responsible for traction, stability, and protecting the wheel from impact damage.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Look for:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Cuts, sidewall damage, or embedded objects</li>
                            <li>Adequate tread depth</li>
                            <li>Uneven wear that may suggest alignment or suspension issues</li>
                            <li>Correct tire pressure for the terrain you plan to drive</li>
                        </ul>
                    </section>

                    <section id="check-2" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            2. Inspect the Spare Tire and Tire Tools
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Many people remember to inspect the four tires on the ground but forget the spare. That can be a serious mistake when you are far from help. A flat tire off-road is much more stressful if the spare is also flat or if you cannot access the tools you need.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Make sure the spare tire is in usable condition, properly inflated, and easy to access. Check that the jack, lug wrench, wheel lock key if applicable, and any lift accessories are present and working.</p>
                        <p className="mb-4 text-gray-700">
                           If your vehicle does not carry a full-size spare, it is even more important to think about the terrain and whether your backup plan is good enough for the trip.
                        </p>
                    </section>

                    <section id="check-3" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            3. Inspect Suspension and Steering Components
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Off-road terrain puts a lot of strain on your suspension and steering system. Washboard roads, rocky trails, ruts, and sudden dips can quickly expose worn bushings, tired shocks, loose tie rods, or other hidden problems.                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Before your trip, pay attention to clunks, looseness in the steering wheel, uneven ride height, leaking shocks, or unusual tire wear. These can all be signs that the vehicle is not ready for rough ground.</p>
                        <p className="mb-4 text-gray-700">
                           If your steering already feels vague or your suspension feels unstable on pavement, it will usually feel much worse off-road.
                        </p>
                    </section>

                    <section id="check-4" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            4. Look at Ground Clearance and Underbody Protection
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Off-road damage often happens underneath the vehicle. Rocks, branches, and uneven terrain can hit low-hanging parts like oil pans, exhaust sections, or fuel tank areas.
                        </p>
                        <p className="mb-0 text-gray-700">
                            Check that any skid plates or protective covers are secure and not already damaged. Look for loose splash shields or vulnerable components.
                        </p>
                    </section>

                    <figure className="mb-10">
                        <img
                            src="/blogs/4_3.jpeg"
                            alt="Inspecting the underbody and suspension before off-road driving"
                            title="Underbody inspection before taking vehicle off-road"
                            className="w-full h-auto block border border-gray-300 rounded-xl"
                        />
                        <figcaption className="text-xs text-gray-400 mt-2">
                            Inline image: offroad_underbody_check.png
                        </figcaption>
                    </figure>

                    <section id="check-5" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            5. Check All Important Fluids
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Off-road driving often means low-speed operation, steep inclines, heavy engine load, and more wheel slip. All of that increases stress on fluid systems. Low or dirty fluids can turn into overheating, poor braking, rough shifting, or power steering issues much faster than during normal road use.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Check these fluids before you leave:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Engine oil</li>
                            <li>Coolant</li>
                            <li>Brake fluid</li>
                            <li>Transmission fluid if applicable</li>
                            <li>Power steering fluid if applicable</li>
                            <li>Winshield washer fluid</li>
                        </ul>
                    </section>

                    <section id="check-6" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            6. Test the Battery and Charging System
                        </h2>
                        <p className="mb-4 text-gray-700">
                            A weak battery is inconvenient anywhere, but it is a much bigger problem when you are far from paved roads and help is not nearby. Off-road trips often involve accessories too, such as lights, compressors, GPS devices, winches, and phone charging.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Check for slow starts, corrosion on terminals, loose battery connections, or signs that the battery is aging. If the battery is already questionable, it is better to address it before the trip instead of hoping it will be fine.</p>
                        <p className="mb-2.5 text-gray-900 font-bold"> A healthy charging system matters too. If the alternator is weak, long low-speed driving with accessories running can create problems.</p>
                        
                    </section>

                    <section id="check-7" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            7. Inspect the Brakes
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Off-road driving often involves steep descents, slippery surfaces, and sudden shifts in traction. Good brakes are essential. If the vehicle already has squeaking, grinding, vibration, or a soft pedal feel, do not ignore it before heading onto rough terrain.</p>
                        <p className="mb-2.5 text-gray-900 font-bold">Listen for unusual noises, pay attention to pedal feel, and make sure the vehicle stops evenly. A brake issue that feels manageable on a short city drive can feel much worse on a downhill trail.</p>
                        <p className="mb-2.5 text-gray-900 font-bold">This is also a good time to confirm that the parking brake works properly, especially if you may need to stop on inclines.</p>
                    </section>

                    <section id="check-8" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            8. Check the Air Filter and Cooling System
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Dusty trails can clog an air filter quickly, and slow off-road driving can stress the cooling system because there is often less airflow than at highway speed. That combination can hurt engine performance and increase the chance of overheating.</p>
                        <p className="mb-2.5 text-gray-900 font-bold">Inspect the engine air filter if you have been driving in dusty conditions recently. Also check coolant level, hoses, radiator condition, and any obvious signs of leakage or overheating history</p>
                        <p className="mb-2.5 text-gray-900 font-bold">If your vehicle runs warm even in normal driving, do not ignore that before taking it into harsher conditions.</p>
                        
                    </section>

                    <section id="check-9" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            9. Pack the Right Recovery Gear
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Recovery gear is one of the biggest differences between a normal road trip and an off-road trip. Even experienced drivers can get stuck in mud, sand, snow, or ruts.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Useful recovery gear may include:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Tow strap or recovery strap</li>
                            <li>Rated recovery points</li>
                            <li>Portable air compressor</li>
                            <li>Tire repair kit</li>
                            <li>Jack suitable for uneven ground</li>
                            <li>Shovel, Gloves, and Flashlight</li>
                        </ul>
                    </section>

                    <section id="dash-section" className="mb-10">
                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
                            <h2 className="text-2xl leading-tight mb-3.5 text-gray-900 font-bold">
                                Track Off-Road Readiness with CarFido
                            </h2>

                            <p className="mb-3.5 text-gray-700">
                                It is easy to forget what your vehicle may need before an off-road trip, especially if you have not checked recent maintenance, fluid condition, or wear items in a while.
                            </p>

                            <p className="mb-3.5 text-gray-700">
                                CarFido helps drivers keep track of maintenance history, understand vehicle symptoms, and stay more organized before road trips, trail days, and weekend adventures.
                            </p>

                            <p className="mb-2.5 text-gray-900 font-bold">Drivers can ask questions such as:</p>

                            <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                                <li>Is my vehicle ready for an off-road trip this weekend?</li>
                                <li>What should I check before taking my SUV onto rocky trails?</li>
                            </ul>
                        </div>
                    </section>

                    <section id="extra-tips" className="mb-11">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Extra Tips Before You Head Off-Road
                        </h2>

                        <ul className="pl-6 m-0 mb-4 space-y-2 text-gray-700 list-disc">
                            <li>Know the trail difficulty before you go</li>
                            <li>Avoid going alone if you are inexperienced</li>
                            <li>Bring a way to air tires back up after the trip</li>
                            <li>Secure loose cargo inside the vehicle</li>
                            <li>Check weather conditions and trail closures</li>
                            <li>Stay within the limits of your vehicle and your driving experience</li>
                        </ul>

                        <p className="mb-0 text-gray-700">
                            The best off-road trips usually start with realistic planning. A well-prepared vehicle and a cautious driver are much more likely to finish the day without damage or unnecessary stress.
                        </p>
                    </section>

                    <section id="faq" className="mb-11 border-t border-gray-200 pt-8">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-5 text-gray-900 font-bold">
                            Frequently Asked Questions
                        </h2>

                        <div className="space-y-1">
                            <FAQitem
                                question="What should I check before taking my vehicle off-road?"
                                answer="Check tires, tire pressure, spare tire, suspension, steering, fluids, brakes, battery, recovery gear, and emergency supplies. You should also make sure the vehicle matches the type of terrain you plan to drive."
                            />
                            <FAQitem
                                question="Do I need to lower tire pressure for off-roading?"
                                answer="Sometimes. Lower tire pressure can improve traction on some surfaces, but the right pressure depends on the vehicle, tires, and terrain. Tires should be reinflated before normal highway driving."
                            />
                            <FAQitem
                                question="Is off-road driving bad for your vehicle?"
                                answer="Off-road driving creates more wear and stress than normal driving, especially on tires, suspension, steering, and the underbody. Proper preparation and careful driving reduce the risk of damage."
                            />
                            <FAQitem
                                question="What recovery gear should I carry for off-roading?"
                                answer="Basic recovery gear may include a tow strap, air compressor, tire repair kit, jack, shovel, flashlight, and gloves. Remote trips may require even more preparation depending on terrain and distance."
                            />
                            <FAQitem
                                question="Can CarFido help me prepare my vehicle for off-road trips?"
                                answer="Yes. CarFido can help you track maintenance history, identify warning signs, review service needs, and build a better understanding of what your vehicle may need before an off-road trip."
                            />
                        </div>
                    </section>

                    <section id="final-thoughts" className="mb-11">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Final Thoughts
                        </h2>

                        <p className="mb-0 text-gray-700">Off-road driving is much more enjoyable when your vehicle is properly prepared. A few checks before you leave can reduce stress, improve safety, and help prevent avoidable damage.</p>
                        <p className="mb-0 text-gray-700">Tires, suspension, fluids, brakes, and recovery gear deserve special attention because they have the biggest impact on traction, control, and reliability once you leave normal roads behind.</p>
                        <p className="mb-0 text-gray-700">Before your next trail run or off-road trip, slow down for a few minutes and inspect the vehicle properly. Good preparation is one of the easiest ways to make the whole trip safer and more enjoyable.</p>

                    </section>

                    {/* Up Next Section */}
                    {/* <div className="mt-20 pt-10 border-t border-gray-100">
                        <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">Up Next</span>
                        <Link to="/maintenance/car-service-intervals" className="group block mt-4">
                            <h3 className="text-2xl font-bold text-gray-900 group-hover:text-black transition-colors">
                                {blogs[0].title}
                            </h3>
                            <p className="mt-2 text-gray-500 line-clamp-2">
                                {blogs[0].excerpt}
                            </p>
                            <div className="mt-4 flex items-center text-black font-bold text-sm">
                                Read Article
                                <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </div>
                        </Link>
                    </div> */}
                </main>

                <aside className="w-full lg:w-[300px] lg:flex-[0_0_300px] lg:sticky lg:top-5 self-start space-y-5">
                    <div className="border border-gray-200 rounded-xl bg-white p-5">
                        <div className="text-base font-bold text-gray-900 mb-3">
                            Quick Navigation
                        </div>

                        <ul className="list-none p-0 m-0 space-y-2.5">
                            <li><a href="#quick-answer" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Quick Answer</a></li>
                            <li><a href="#checklist-table" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Checklist Summary</a></li>
                            <li><a href="#why-it-matters" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Why it Matters</a></li>
                            <li><a href="#check-1" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Tires & Pressure</a></li>
                            <li><a href="#check-4" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Suspension</a></li>
                            <li><a href="#check-4" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Fluids</a></li>
                            <li><a href="#check-4" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Brakes</a></li>
                            <li><a href="#check-9" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Recovery Gear</a></li>
                            <li><a href="#check-4" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Extra steps</a></li>
                            <li><a href="#faq" className="no-underline text-gray-600 hover:text-gray-900 text-sm">FAQ</a></li>
                        </ul>
                    </div>

                    <div className="border border-gray-200 rounded-xl bg-gray-50 p-5">
                        <div className="text-base font-bold text-gray-900 mb-2.5">
                            Related Reads
                        </div>
                        {(() => {
                            const otherBlogs = blogs.filter(b => b.id !== 4);
                            const startIndex = 4 % otherBlogs.length;
                            return [...otherBlogs.slice(startIndex), ...otherBlogs.slice(0, startIndex)].slice(0, 3);
                        })().map((relatedBlog) => (
                            <Link
                                key={relatedBlog.id}
                                to={relatedBlog.path}
                                className="block no-underline text-gray-900 mb-3 text-sm leading-snug font-medium hover:text-gray-600 transition-colors"
                            >
                                {relatedBlog.title}
                            </Link>
                        ))}
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default Blog4;
